import {
    createOtherCategoriesByPageSelector,
    otherCategoriesTotalResultsSelector,
} from '@/redux/modules/otherCategories/otherCategories.selectors';
import { defaultOtherCategoriesOptions, defaultOtherCategoriesPageSize } from './constants/otherCategoriesConstants';
import { fetchOtherCategoriesIfNeeded } from '@/redux/modules/otherCategories/otherCategories';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { noop } from 'es-toolkit';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { useGetQueryParams } from '@/hooks/queryParams/useGetQueryParams';
import OtherCategoryCard from '@/pages/DiscoverCategories/components/DiscoverCategories/components/OtherCategories/OtherCategoryCard/OtherCategoryCard';
import Pagination from '@/components/Pagination/hammer-pagination/Pagination';
import React, { ReactElement, useEffect, useState } from 'react';
import styled from 'styled-components';

const OtherCategories = (props, ref: React.MutableRefObject<HTMLDivElement>): ReactElement => {
    const dispatch = useAppDispatch();
    const getQueryParams = useGetQueryParams();
    const { page = 1, pageSize = defaultOtherCategoriesPageSize } = getQueryParams({ parseNumbers: true });
    const [currentCategories, setCurrentCategories] = useState([]);
    const categories = useAppSelector(createOtherCategoriesByPageSelector(page, pageSize));
    const totalResults = useAppSelector(otherCategoriesTotalResultsSelector);

    useEffect(() => {
        dispatch(fetchOtherCategoriesIfNeeded(page, pageSize));
    }, [dispatch, page, pageSize]);

    useEffect(() => {
        if (categories) {
            setCurrentCategories(categories);
        }
    }, [categories]);

    return (
        <StyledOtherCategories>
            <StyledTitleSpacer ref={ref} />
            <StyledTitle>
                <FormattedMessage id="discoverPage.otherCategories.title" />
            </StyledTitle>
            <Pagination
                onChange={noop}
                pageSizeOptions={defaultOtherCategoriesOptions}
                paginationFilter={{
                    page,
                    pageSize,
                    totalRecords: totalResults,
                }}
                restrictPagesTo={10}
                shouldModifyQueryParams
            >
                <StyledCardsBox>
                    {currentCategories.map((category) => (
                        <OtherCategoryCard
                            category={category}
                            key={category.title}
                        />
                    ))}
                </StyledCardsBox>
            </Pagination>
        </StyledOtherCategories>
    );
};

export default React.forwardRef(OtherCategories);

const StyledOtherCategories = styled.section`
    margin-left: 32px;
    margin-top: 24px;
`;

const StyledTitleSpacer = styled.div`
    height: 40px;
`;

const StyledTitle = styled.h2`
    margin-bottom: 32px;
`;

const StyledCardsBox = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
`;
